<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        Loader(v-if="getMedGroup === false && stage === 'medGroupList'")
        div.med-group-wrapper(v-if="getMedGroup && stage === 'medGroupList' && Object.values(group).length !== 0")
          ul.nav.nav-pills.nav-fill.nav-autoix
            li.nav-item(v-for="g, index in group" @click="currentGroupIndex = index")
              div.nav-link(:class="{ 'active': currentGroupIndex === index }" ) {{g.name}}
          div.med-select
            div.med-button(
              :class="{ 'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0 }"
              v-for="med, index in group[currentGroupIndex].medicine_set"
              @click="selectMed(index)") 
              div#med_desc
                h6 {{ med.code }} - {{ med.CGMH_number }}
                h6 {{ med.generic_name }}
              div#remain_amount 
                span 系統存量
                span {{ med.amountInSystem }}
        div.with-child-centered(v-if="getMedGroup && stage === 'medGroupList' && Object.values(group).length === 0")
          h4 未設定類別藥物
        MultiFlow(
          v-if="stage === 'startFlow'"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          :actionProgress="actionProgress"
          v-on:setAllConfirmData="getAllConfirmData"
        )
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel" :clickable="currentApp.cancel")
      action-button(title="醫囑取藥" slot="button-3" @click.native="$router.push({ name: 'schedule', params: { stage: 'ComboMedListAndPatient' } })" v-if="$store.state.user.user.med_app_privilege.fetch_by_schedule && stage !== 'startFlow'")
      //- action-button(title="套藥取藥" slot="button-4" @click.native="$router.push({ name: 'fetchDrugCombo' })" v-if="$store.state.user.user.med_app_privilege.fetch_by_schedule")
      action-button(title="開始取藥" slot="button-9" @click.native="startFlow" v-if="stage !== 'startFlow'" :clickable="DrugsForFetchList.length > 0")

              
</template>

<script>
import _ from 'lodash';
import progressBar from './flowComp/ProgressBar';
import Loader from './common/Loader';
import MultiFlow from './FetchDrugGroupFlow/MultiFlow';
import BottomButtons from './common/BottomButtons';
import AppBase from './ComponentBase/AppBase';


export default {
  name: 'FetchDrugGroup',
  extends: AppBase,
  components: {
    progressBar,
    Loader,
    MultiFlow,
    BottomButtons,
  },
  data() {
    return {
      group: [],
      getMedGroup: false,
      currentGroupIndex: 0,
      stage: 'medGroupList',
      scheduleId: null,
    };
  },
  created() {
    this.stage = 'medGroupList';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.getGroup();
  },
  computed: {
    DrugsForFetchList() {
      return this.$store.state.drug.DrugsForFetchList;
    },
  },
  methods: {
    setupProgress() {
      const p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push({ en: 'medIdInput', zh: '輸入病歷號' });
      }
      //20190422 add 覆核動作
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    setupMultiProgress() {
      const p = [];
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push('medIdInput');
      }
      p.push('confirm');
      p.push('finish');
      return p;
    },
    setupConfirmProgress() {
      //20190422 modified
      /*
      return [
        'start',
        'action',
      ];
      */
      const prog = [];
      prog.push('start');
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      return prog;
    },
    setupActionProgress() {
      const prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    getGroup() {
      this.instance.get('/api/medication-group/')
      .then((res) => {
        res.data.forEach((group) => {
          group.medicine_set.forEach((item) => {
            item.selected = false;
            item.drugInDevice = _.filter(this.$store.getters.drugInDeviceList, (drugStorage) => {
              return drugStorage.medication.id === item.id && drugStorage.stock > 0;
            });
            item.amountInSystem = 0;
            item.drugInDevice.forEach((d) => {
              item.amountInSystem += d.stock;
            });
          });
        });
        this.group = res.data;
        this.getMedGroup = true;
      });
    },
    selectMed(index) {
      const med = this.group[this.currentGroupIndex].medicine_set[index];
      med.selected = !med.selected;
      const payload = {
        med,
        drugStorage: med.drugInDevice,
        amount: 1,
        select: med.selected,
      };
      this.$store.dispatch('setDrugListForFetch', payload);
    },
    cancel() {
      this.$router.push({ name: 'Main' });
    },
    startFlow() {
      for (let i = 0; i < this.$store.state.drug.DrugsForFetchList.length; i += 1) {
        const fetchItem = this.$store.state.drug.DrugsForFetchList[i];
        if (fetchItem.med.restrained_class > 0) {
          this.$store.dispatch('printQR', fetchItem);
        }
      }
      this.stage = 'startFlow';
    },
    getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      //20190411 add by aaron
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'ScheduleList';
      this.$router.push({ name: 'schedule' });
    },
  },
};
</script>

<style lang="sass">




      

</style>



// WEBPACK FOOTER //
// FetchDrugGroup.vue?e1b1cedc